
import lazyload from "@/directives/lazyload";
import polish from "@/assets/images/landing/svg/polish-hearts.svg";
import jdate from "@/assets/images/landing/svg/jdate.svg";
import parents from "@/assets/images/landing/svg/for-parents.svg";
import lovo from "@/assets/images/landing/svg/lovoo.svg";
import mico from "@/assets/images/landing/svg/mico.svg";
import lavalife from "@/assets/images/landing/svg/lavalife.svg";
import okcupid from "@/assets/images/landing/svg/okcupid.svg";
import zoosk from "@/assets/images/landing/svg/zoosk.svg";
export default {
  data() {
    return {
      images: {
        polish,
        jdate,
        parents,
        lovo,
        mico,
        lavalife,
        okcupid,
        zoosk,
      },
    };
  },
  directives: {
    lazyload,
  },
};
